/* esm.sh - three-mesh-bvh@0.9.10/src/core/GeometryBVH */
export * from "/*three-mesh-bvh@0.9.10/esnext/src/core/GeometryBVH.mjs";
